/**
 * TRIL-628: ONE identity per failure, shared by web and mobile.
 *
 * Both surfaces previously declared their own `LegacyMediaKeyError`. Two classes with the same
 * name are not the same class — `instanceof` across them is false — so any code that ever handles
 * a key resolved on one surface and an error raised on the other would silently take the wrong
 * branch and show the wrong copy. That is precisely how TRIL-615 and TRIL-622 produced real bugs.
 */

/**
 * The object predates owner-bound keys (TRIL-617): it sits at the bucket root as `<uuid>.<ext>`
 * with nothing identifying an owner, so the server refuses it permanently. NO retry can succeed,
 * by anyone, on any surface — callers must not advise one. Cleanup is TRIL-625.
 */
export class LegacyMediaKeyError extends Error {
  constructor(readonly key: string) {
    super(`Legacy image key has no owner prefix and cannot be deleted: ${key}`);
    this.name = 'LegacyMediaKeyError';
  }
}

/** The block carries an image url we could not turn into a key — storage was never contacted. */
export class UnresolvableMediaKeyError extends Error {
  constructor(readonly url: string) {
    super(`Could not resolve an S3 key for: ${url}`);
    this.name = 'UnresolvableMediaKeyError';
  }
}
